import { Modal, Popover } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// api
import { whatsappBusinessNumbers } from "../../../../../../api/Api";
import { getSingleCampaign } from "../../../../../../api/apiClients/campaign";

// assets
import { ICONS } from "../../../../../../assets/icons";
import Meta from "../../../../../../assets/customSVG/sequence/Meta";

// helper

// redux
import {
  useAspDispatch,
  useAspSelector,
} from "../../../../../../test/jest-redux-hooks";

// hooks
import useToggle from "hooks/useToggle";

// components
import Loader from "../../../../../../components/commonComponents/Loader/Index";
import Header from "../../../../../../components/commonComponents/modals/Header";
import SearchBar from "../../../../../../components/commonComponents/searchBar";
import NewRadioButton from "../../../../../../components/form/radio/NewRadio";
import { cn } from "../../../../../../helper/cn";
import { SORT } from "../../../../constants/campaignList";
import dayjs from "dayjs";
import { dateConverter } from "../../../../../../helper/dateConverter";

const SEND_SETTINGS = [
  {
    id: 1,
    label: "Send Now",
    key: "send_now",
    isDisabled: false,
  },
  {
    id: 2,
    label: "Send Later",
    key: "send_later",
    isDisabled: false,
  },
];

export default function New({
  data,
  onChange,
  setSellectedTemplate,
  sequenceDetails,
  campaignsName,
  campaignsAds,
  fbAds,
}) {
  const { campaign_id } = useParams();
  const { currentBrand } = useAspSelector((state) => state.app);
  const dispatch = useAspDispatch();

  const [isLoading, setIsLoading] = useToggle(false);
  const [isLoadings, setIsLoadings] = useToggle(false);
  const [isOpen, setIsOpen] = useState({ campaign: false, ads: false });
  const [isOpenModal, setIsOpenModal] = useToggle(false);
  const [list, setList] = useState([]);
  const [campaignDetails, setCampaignDetails] = useState(null);
  const [sendSettings, setSendSettings] = useState(SEND_SETTINGS);

  useEffect(() => {
    const date = moment() < moment(sequenceDetails?.start_date);

    if (date) {
      const res = sendSettings?.map((s) => {
        if (s?.key === "send_now") return { ...s, isDisabled: true };
        return s;
      });
      setSendSettings(res);
    }
  }, [data]);

  useEffect(() => {
    if (currentBrand) {
      getwhatsappBusinessNumbers(currentBrand?.brand_id);
      getCampaignDetails(currentBrand?.brand_id);
    }
  }, [currentBrand]);

  const getwhatsappBusinessNumbers = async (brand_id) => {
    setIsLoading(true);
    setIsLoadings(true);
    try {
      const res = await whatsappBusinessNumbers(brand_id);
      setList(res?.data?.wapp_business_num);
      count = res?.data?.wapp_business_num_count;
    } catch (error) {
      console.warn(error);
    } finally {
      setIsLoading(false);
      setIsLoadings(false);
    }
  };

  const getCampaignDetails = async (brand_id) => {
    setIsLoading(true);
    try {
      const res = await getSingleCampaign(brand_id, campaign_id);
      setCampaignDetails(res?.data);
    } catch (error) {
      console.warn(error);
    } finally {
      setIsLoading(false);
    }
  };

  const isOptionSelected = (option) => {
    return option?.id === data?.sendFrom?.id;
  };

  const handleCanceltemplateModal = () => setIsOpenModal(false);

  return (
    <div>
      <div className="flex flex-col gap-2  ">
        <span className="font14px-500 text-[var(--font-600)]">
          Campaign Name
        </span>

        <Popover
          trigger={"click"}
          open={isOpen["campaign"]}
          onOpenChange={(open) =>
            setIsOpen((prev) => ({ ...prev, campaign: open }))
          }
          placement="bottomLeft"
          arrow={false}
          content={
            <ul
              className={`w-full min-w-[25rem]  m-0 list-none rounded-2xl flex-col gap-1.5 overflow-y-scroll listScroll bg-[var(--white)] z-50 prl-10 ${
                isOpen["campaign"] ? "flex" : "hidden"
              }`}
            >
              {isLoadings ? (
                <div className="w-100 h-[7vh] flex-row align-center justify-center">
                  <Loader Width={25} Height={25} />
                </div>
              ) : (
                <div className="h-50 max-h-[30vh]">
                  {campaignsName?.map((option, index) => {
                    return (
                      <div
                        key={option?.id}
                        className="w-full  flex items-center justify-between  cursor-pointer"
                        onClick={() => {
                          setIsOpen((prev) => ({ ...prev, campaign: false }));
                          onChange({
                            type: "UPDATE_NODE",
                            id: data?.uniq_id,
                            primaryKey: "data",
                            key: "settings",
                            data: {
                              ...data?.data?.settings,
                              campaign_name: option?.name,
                              fb_campaign_id: option?.id,
                            },
                          });
                        }}
                      >
                        <div
                          className={`w-100 flex flex-column border-b border-b-[var(--border-input)] ${
                            index === campaignsName?.length - 1
                              ? "border-b-0"
                              : ""
                          }`}
                        >
                          <p
                            className={`font14px-600 text-[var(--textBlack)] pl-10 mtb-10 ptb-10 b-radius-6  ${
                              option?.name ===
                              data?.data?.settings?.campaign_name
                                ? "bg-[--new-primary-bg]"
                                : "hover:bg-[--BG-25]"
                            }`}
                          >
                            {option?.name}
                          </p>
                        </div>
                        {isOptionSelected(option) && (
                          <img
                            src={ICONS?.Selected}
                            alt="selected"
                            className="size-5"
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </ul>
          }
        >
          <div className="flex-column input-label-text pointer">
            <div className="flex-row align-center space-between border border-[var(--border-input)] p-10 b-radius-6 font14px-500 ">
              {data?.data?.settings?.campaign_name ? (
                <span className="text-[var(--textBlack)]">
                  {data?.data?.settings?.campaign_name}
                </span>
              ) : (
                <span className="text-[var(--font-600)]">
                  Select the Ad Campaign
                </span>
              )}
              <img
                src={ICONS?.modelDropdownIcon}
                alt="modelDropdownIcon"
                className="pointer"
              />
            </div>
          </div>
        </Popover>
      </div>
      <div className="flex flex-col  pt-15 ">
        <span className="font14px-500 text-[var(--font-600)] pb-5">
          Ad Set Name
        </span>

        <Popover
          trigger="click"
          open={isOpen["ads"]}
          onOpenChange={(open) => setIsOpen((prev) => ({ ...prev, ads: open }))}
          placement="bottomLeft"
          arrow={false}
          content={
            <ul
              className={`w-full min-w-[25rem] m-0 list-none rounded-2xl flex-col gap-1.5 overflow-y-scroll listScroll bg-[var(--white)] z-50 p-2.5 ${
                isOpen["ads"] ? "flex" : "hidden"
              }`}
            >
              {isLoadings ? (
                <div className="w-100 h-[7vh] flex-row align-center justify-center">
                  <Loader Width={25} Height={25} />
                </div>
              ) : (
                <>
                  {campaignsAds?.map((option, index) => {
                    const date = dateConverter(option?.starts);
                    return (
                      <div
                        key={option?.id}
                        className="w-full flex justify-between  cursor-pointer"
                        onClick={() => {
                          setIsOpen((prev) => ({ ...prev, ads: false }));

                          onChange({
                            type: "UPDATE_NODE",
                            id: data?.uniq_id,
                            primaryKey: "data",
                            key: "settings",
                            data: {
                              ...data?.data?.settings,
                              campaign_ads: option?.name,
                              fb_ad_set_id: option?.id,
                            },
                          });
                        }}
                      >
                        <div
                          className={`w-100 flex flex-col border-b border-b-[var(--border-input)] ptb-5 ${
                            index === campaignsAds.length - 1
                              ? "border-b-0"
                              : ""
                          }`}
                        >
                          <div
                            className={`p-5 b-radius-6 ${
                              option?.name ===
                              data?.data?.settings?.campaign_ads
                                ? "bg-[var(--new-primary-bg)]"
                                : "hover:bg-[var(--BG-50)]"
                            }`}
                          >
                            <p className="font14px-600 text-[var(--textBlack)] pl-10 ">
                              {option?.name}
                            </p>
                            <div className="w-100 flex-row align-center space-between">
                              <p className="font12px-400 text-[var(--font-600)] pl-10">
                                {option?.contact}
                              </p>
                              <p className="font12px-400 text-[var(--font-600)] pt-10 pr-10">
                                Starts:{"  "}
                                <span className="font12px-600 text-[var(--textBlack)] bg-[#CCE5D6] p-5 rounded-[4px]">
                                  {date?.monthInShort} {date?.date},{" "}
                                  {date?.year}
                                </span>
                              </p>
                            </div>
                          </div>
                        </div>
                        {isOptionSelected(option) && (
                          <img
                            src={ICONS?.Selected}
                            alt="selected"
                            className="size-5"
                          />
                        )}
                      </div>
                    );
                  })}
                </>
              )}
            </ul>
          }
        >
          <div className="flex-column input-label-text pointer">
            <div className="flex-row align-center space-between border border-[var(--border-input)] p-10 b-radius-6 font14px-500 ">
              {data?.data?.settings?.campaign_ads ? (
                <span className="text-[var(--textBlack)]">
                  {data?.data?.settings?.campaign_ads}
                </span>
              ) : (
                <span className="text-[var(--font-600)]">Select adset</span>
              )}
              <img
                src={ICONS?.modelDropdownIcon}
                alt="modelDropdownIcon"
                className="pointer"
              />
            </div>
          </div>
        </Popover>
      </div>
      <div className="flex flex-col  pt-15 ">
        <span className="font14px-500 text-[var(--font-600)] pb-5">
          Choose Ad
        </span>

        {data?.data?.settings?.fb_datas && (
          <div className="border border-[var(--border-input)] b-radius-6 ">
            <div className="flex-row align-center p-10 ">
              <img
                src={data?.data?.settings?.url}
                alt=""
                className="b-radius-6 w-20"
              />

              <div className="flex-column pl-10 capitalize">
                <span className="w-90 truncate font14px-500 text-[var(--textBlack)]">
                  {data?.data?.settings?.fb_datas?.name}
                </span>
                <span className="w-[35ch] truncate font13px-400 text-[var(--font-600)]"></span>
                <span className="font16px-400 text-[var(--font-700)]"></span>
              </div>
            </div>
          </div>
        )}

        <div
          className="flex-row align-center justify-center gap-2 space-between border border-[var(--border-input)] p-10 mt-15 b-radius-6 font14px-500 text-[var(--font-600)] pointer"
          onClick={() => {
            setIsOpenModal(true);
          }}
        >
          <span>Change Ad</span>
        </div>
      </div>

      <Modal
        open={isOpenModal}
        centered
        footer={null}
        closable={false}
        styles={{content: {padding: 0}}}
        mask={true}
        wrapClassName={"bg-[#00000095]"}
        onCancel={handleCanceltemplateModal}
        destroyOnClose
        width={"60vw"}
        style={{
          width: "100%",
          borderRadius: 20,
          boxShadow: "0px 10px 24px 0px rgba(79, 92, 128, 0.15)",
        }}
      >
        <Header
          title="Meta Ads"
          titleSize="largest"
          rootStyle="!px-[1.5vw] !py-[1vw] gap-2"
          handleCancel={handleCanceltemplateModal}
          prefix={<Meta color="#0064E0" />}
        />

        <div className="w-100 flex-row align-center gap-3 space-between px-[1.5vw] py-[1vw]">
          <span className="new-header3 invisible">{``}</span>

          <div className="flex-row align-center gap-2.5">
            <SearchBar
              //   searchKey={searchKey}
              //   setSearchKey={setSearchKey}
              //   // className="!w-[15vw]"
              //   onChange={(val) => {
              //     onSearch(val);
              //   }}
              //   search="search-template"
              //   searchCancel="searchCancel"
              expandable={true}
            />

            <Popover
              trigger={["click"]}
              placement="bottom"
              arrow={false}
              content={
                <div className="min-w-56 px-3.5 py-2.5">
                  {SORT?.map((section) => (
                    <div key={section?.heading}>
                      <h3 className="new-header1 mb-2 pt-5">
                        {section.heading}
                      </h3>
                      {section?.options?.map((s) => (
                        <div
                          key={s.id}
                          className={cn(
                            "w-full h-9 flex items-center gap-2.5 py-1 "
                          )}
                          // onClick={() => {
                          //   if (["all-campaigns"]?.includes(goalType)) {
                          //     onSortChange(section?.id, s);
                          //   }
                          // }}
                        >
                          <div className="w-5 h-9 flex items-center justify-center mt-1">
                            <NewRadioButton
                              value={s?.isSelected}
                              selected={s?.isSelected}
                              onChange={(e) => {}}
                              rootClassName={
                                s?.isSelected && "size-3.5 new-radio"
                              }
                            />
                          </div>
                          {s?.icon && <img src={s?.icon} alt={s.label} />}
                          <p>{s?.label}</p>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              }
            >
              <div className="group/sort flex items-center gap-2.5 bg-[var(--BG-25)] px-3 py-1.5 rounded-[0.4vw] cursor-pointer">
                <div className="campaign-filters">
                  {/* {sortLabel || "Newest First"} */}
                  {"Newest First"}
                </div>
                <div
                  className={cn(
                    "transition-transform duration-200 ease-linear",
                    // group-hover/sort:-rotate-180,
                    false ? "-rotate-180" : "rotate-0",
                    isLoading ? "cursor-not-allowed" : "cursor-pointer"
                  )}
                >
                  <div
                    className={`border-[0.4vw] rounded-t-[0.2vw] border-transparent border-t-[#777] translate-y-[25%]`}
                  ></div>
                </div>
              </div>
            </Popover>
          </div>
        </div>
        <div className="w-100 grid grid-cols-2 gap-7 px-[1.5vw] py-[1vw]">
          {fbAds?.map((option) => {
            return (
              <div
                key={option?.id}
                className={` cursor-pointer border border-[var(--border-input)] b-radius-6 overflow-hidden ${
                  data?.data?.settings?.fb_datas?.name === option?.name
                    ? "border-[var(--new-primary)]"
                    : ""
                }`}
                onClick={() => {
                  setIsOpen((prev) => ({ ...prev, campaign: false }));

                  onChange({
                    type: "UPDATE_NODE",
                    id: data?.uniq_id,
                    primaryKey: "data",
                    key: "settings",
                    data: {
                      ...data?.data?.settings,
                      ads: option?.name,
                      url: option?.creative?.thumbnail_url,
                      fb_datas: option,
                    },
                  });
                }}
              >
                <div className="w-100  flex flex-col gap-2.5 ">
                  <p className="font14px-600 text-[var(--textBlack)] pt-5 capitalize pl-10">
                    {option?.name}
                  </p>
                  <p className="font13px-400 text-[var(--font-600)] pl-10">
                    {option?.creative?.object_story_spec?.link_data?.message}
                  </p>
                  <div className="h-[100px] object-cover">
                    <img
                      src={option?.creative?.thumbnail_url}
                      alt=""
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="w-95 flex-row align-end justify-end   font13px-500 text-[var(--textBlack)] m-10">
                    {option?.creative?.object_story_spec?.link_data
                      ?.call_to_action?.value?.app_destination && (
                      <span className="bg-[#D1D3D8] px-3 py-2 b-radius-6">
                        {
                          option?.creative?.object_story_spec?.link_data
                            ?.call_to_action?.value?.app_destination
                        }
                      </span>
                    )}
                  </div>
                </div>
                {isOptionSelected(option) && (
                  <img
                    src={ICONS?.Selected}
                    alt="selected"
                    className="size-5"
                  />
                )}
              </div>
            );
          })}
        </div>
        <div
          className="w-100 flex align-end justify-end py-3 px-4 sticky"
          onClick={() => setIsOpenModal(false)}
        >
          <button className="px-2.5 py-1.5 bg-[var(--new-primary)] text-[var(--white)] font16px-600 rounded-[5px]">
            Add Ad
          </button>
        </div>
      </Modal>
    </div>
  );
}
